function ShippingQuoteValidation (cvalidation) {
    this.cvalidation = cvalidation;

    // methods
    this.generateGlobalErrorMessages = function () {
        var content = '';
        if (this.cvalidation == null) {
            return content;
        }
        if (this.cvalidation.hasGlobalErrorMessages) {
            var globalErrorMessages = this.cvalidation.globalErrorMessages;
            content += '<ul class="validationErrorMessage">';
            for (var i = 0, ni = globalErrorMessages.length; i < ni; i++) {
                var cmessage = globalErrorMessages[i];
                content += '<li>' + cmessage.value + '</li>';
            }
            content += '</ul>';
        }
        return content;
    };
    this.generateGlobalInfoMessages = function () {
        var content = '';
        if (this.cvalidation == null) {
            return content;
        }
        if (this.cvalidation.hasGlobalInfoMessages) {
            var globalInfoMessages = this.cvalidation.globalInfoMessages;
            content += '<ul class="validationInfoMessage">';
            for (var i = 0, ni = globalInfoMessages.length; i < ni; i++) {
                var cmessage = globalInfoMessages[i];
                content += '<li>' + cmessage.value + '</li>';
            }
            content += '</ul>';
        }
        return content;
    };
    this.generateGlobalMessages = function () {
        var content = '';
        if (this.cvalidation == null) {
            return content;
        }
        content += this.generateGlobalErrorMessages();
        content += this.generateGlobalInfoMessages();
        return content;
    };
    this.hasShippingQuoteFieldMessagesFor = function (fieldName) {
        if (this.cvalidation == null) {
            return false;
        }
        if (this.cvalidation.shippingQuoteFieldMessages == null) {
            return false;
        }
        var fieldMessages = this.cvalidation.shippingQuoteFieldMessages;
        for (var i = 0; i < fieldMessages.length; i++) {
            var fieldMessage = fieldMessages[i];
            if (fieldMessage.fieldName == fieldName) {
                return true;
            }
        }
        return false;
    };
    this.generateShippingQuoteFieldMessagesFor = function (fieldName) {
        var content = '';
        if (this.cvalidation == null) {
            return content;
        }
        var fieldMessages = this.cvalidation.shippingQuoteFieldMessages;
        content += '<div class="fieldErrorNote">';
        for (var i = 0; i < fieldMessages.length; i++) {
            var fieldMessage = fieldMessages[i];
            if (fieldMessage.fieldName == fieldName) {
                content += fieldMessage.value + ' ';
            }
        }
        content += '</div>';
        return content;
    };
    this.generateFullSummary = function () {
        var content = '';
        if (this.cvalidation != null && (this.cvalidation.globalMessages != null || this.cvalidation.shippingQuoteFieldMessages != null)) {
            content += '<ul>';
            var globalErrorMessages = this.cvalidation.globalErrorMessages;
            if (globalErrorMessages != null) {
                for (var i = 0, ni = globalErrorMessages.length; i < ni; i++) {
                    var cmessage = globalErrorMessages[i];
                    content += '<li>' + cmessage.value + '</li>';
                }
            }
            var globalInfoMessages = this.cvalidation.globalInfoMessages;
            if (globalInfoMessages != null) {
                for (var i = 0, ni = globalInfoMessages.length; i < ni; i++) {
                    var cmessage = globalInfoMessages[i];
                    content += '<li>' + cmessage.value + '</li>';
                }
            }
            var shipMessages = this.cvalidation.shippingQuoteFieldMessages;
            if (shipMessages != null) {
                for (var i = 0; i < shipMessages.length; i++) {
                    var shipMessage = shipMessages[i];
                    content += '<li>' + shipMessage.fieldName + ' ' + shipMessage.value + '</li>';
                }
            }
            content += '</ul>';
        }

        return content;
    };
    this.setValidationErrorReasons = function (validator) {
        if (this.cvalidation != null) {
            var globalErrorMessages = this.cvalidation.globalErrorMessages;
            if (globalErrorMessages != null) {
                for (var i = 0, ni = globalErrorMessages.length; i < ni; i++) {
                    var cmessage = globalErrorMessages[i];
                    validator.addItem({
                        isValid: function () {
                            return false;
                        },
                        reason: cmessage.value
                    });
                }
            }
            var shipMessages = this.cvalidation.shippingQuoteFieldMessages;
            if (shipMessages != null) {
                for (var i = 0, ni = shipMessages.length; i < ni; i++) {
                    var cmessage = shipMessages[i];
                    validator.addItem({
                        isValid: function () {
                            return false;
                        },
                        reason: cmessage.value
                    });
                }
            }
        }
    };
}
